import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useUserStore } from '../../stores/userStore';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { useColorScheme } from '../../contexts/ColorSchemeContext';
import { supportApi } from './api';
import SupportPromotionCreative from './SupportPromotionCreative';

export default function SupportPromotionCard({ surface, afterSection, exposureAllowed = true }) {
  const { locale } = useWebLocale();
  const { resolvedMode } = useColorScheme();
  const userId = useUserStore((state) => state.user?.id);
  const config = useQuery({
    queryKey: ['support-promotion'],
    queryFn: ({ signal }) => supportApi.promotion(signal),
    staleTime: 60000,
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    retry: false,
  });
  const placement = config.data?.placements?.find(
    (item) => item.surface === surface && item.afterSection === afterSection,
  );
  // Build60: each configured placement is independent; old exposure/hide history is ignored.
  const visible = Boolean(exposureAllowed && config.isSuccess && config.data?.enabled && placement);
  const status = useQuery({
    queryKey: ['sponsorships', 'me', userId],
    queryFn: ({ signal }) => supportApi.mine(signal),
    enabled: Boolean(userId && visible),
    retry: false,
    staleTime: 60000,
    refetchOnWindowFocus: true,
  });
  if (!visible) return null;
  const supporter = Boolean(userId && status.data?.isSupporter === true);
  return (
    <div className="pp-support-promotion">
      <SupportPromotionCreative
        variant={placement.variant}
        english={locale === 'en'}
        dark={resolvedMode === 'dark'}
        supporter={supporter}
        to={supporter ? '/sponsorship/benefits' : '/sponsorship'}
      />
    </div>
  );
}
